import React from "react";
import * as Styled from "./CareerContentCompStyled";

type CareerContentCompProps = {
    category: string;
    jobTitle?: string;
    jobContent: string;
    jobLinkUrl: string;
    jobLinkTitle: string;
}

const CareerContentItemComp = (props: CareerContentCompProps) => {
    return (

        <React.Fragment>

            <Styled.CareerContentJobListItem>
                {props.jobTitle ? (
                    <Styled.CareerContentJobListItemContentTitle>
                        {props.jobTitle}
                    </Styled.CareerContentJobListItemContentTitle>
                ) : null}
                {props.jobContent ? (
                    <Styled.CareerContentJobListItemContentText dangerouslySetInnerHTML={{__html: props.jobContent}}>
                        {/*{props.jobContent}*/}
                    </Styled.CareerContentJobListItemContentText>
                ) : null}
                {props.jobLinkUrl ? (
                    <Styled.CareerContentJobListItemLink href={props.jobLinkUrl}>
                        {props.jobLinkTitle}
                    </Styled.CareerContentJobListItemLink>
                ) : null}
            </Styled.CareerContentJobListItem>
        </React.Fragment>
    )
};

export default CareerContentItemComp;
